import FreeSens from 'assets/img/freesensLittle.svg';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowDown';
import {Backdrop, Grid} from '@mui/material';
import {makeStyles} from '@mui/styles';
import styles from 'assets/jss/AgentStyles/DashboardStyle';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {styled} from '@mui/material/styles';
import {useState} from 'react';
import AgentAccData from 'components/Agent/AgentAccData';
import DotLoading from 'components/Loading/DotLoading';
import useAgentInfo from 'hooks/useAgentInfo';
import {useAppType} from "hooks/useAppType";

const useStyles = makeStyles(styles);

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    zIndex: '5',
    border: 'none !important',
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={
            <KeyboardArrowUpIcon sx={{fontSize: '1rem', color: '#707070'}}/>
        }
        {...props}
    />
))(({theme}) => ({
    flexDirection: 'row-reverse',
    padding: '5px 24px 5px',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
    padding: '0',
}));

export default function AgentAccordion() {
    const classes = useStyles();
    const [expanded, setExpanded] = useState('');
    const {data, isLoading} = useAgentInfo();
    const {data: appType, isLoadingAppType} = useAppType();

    const handleClose = () => {
        setExpanded(false);
    };

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const userInfo = data;
    const scanCenterName = userInfo?.isScanCenter
        ? userInfo?.scanCenterName ?? ''
        : userInfo?.isScanCenter === false
            ? `${userInfo?.firstName ?? ''} ${userInfo?.lastName ?? ''}`
            : '';

    const Loading = () => (
        <div
            style={{
                display: 'right',
                justifyContent: 'right',
                marginRight: '5px',
            }}>
            <DotLoading width={30} height={20}/>
        </div>
    );

    return (
        <>
            <Backdrop
                sx={{
                    zIndex: '5',
                    background: 'rgba(112, 112, 112, 0.5)',
                    backdropFilter: 'blur(3px)',
                }}
                open={expanded === 'panel1'}
                onClick={handleClose}
            />
            <Accordion
                sx={{
                    background:
                        expanded === 'panel1' ? '#FEFEFE ' : '#FDFDFD  !important',
                    borderRadius: expanded === 'panel1' ? '0 0 16px 16px' : '0',
                }}
                expanded={expanded === 'panel1'}
                onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls='panel1d-content' id='panel1d-header'>
                    <Grid container sx={{display: 'flex', alignItems: 'center'}}>
                        <Grid xs={appType?.isReleaseEnv ? 6 : 4}
                              className={classes.agentName}>
                            {isLoading ? <Loading/> : `${scanCenterName ?? ''}`}
                        </Grid>
                        {!appType?.isReleaseEnv &&
                            <Grid item
                                  xs={3.8}
                                  sx={{
                                      display: 'flex',
                                      textAlign: '',
                                      alignItems: 'flex-start',
                                      justifyContent: 'center',
                                  }}
                                  className={classes.devText}
                            >
                                {!isLoadingAppType && appType?.env}
                            </Grid>
                        }
                        <Grid item xs={appType?.isReleaseEnv ? 6 : 4.2}
                              sx={{textAlign: 'left'}}>
                            <img src={FreeSens} alt='FreeSens logo'/>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <AgentAccData handleClose={handleClose}/>
                </AccordionDetails>
            </Accordion>
        </>
    );
}
